module.exports = __webpack_public_path__ + "img/together-buy@2x.31beee5f.png";